import type { AnySection, Group, GroupBase } from '@wix/add-panel-common';
import { assoc, map, pipe } from 'ramda';
import { sortByIndex } from '../array';
import { filterEntitiesWithChildren } from './common';

export const addSections = (allSections: AnySection[], groups: GroupBase[]) => {
  const sectionsByGroup = new Map<string, AnySection[]>(groups.map((gr) => [gr.systemId, []]));
  for (const section of allSections) {
    if (section.groupIds) {
      for (const groupId of section.groupIds) {
        // expecting no duplicates
        sectionsByGroup.get(groupId)?.push(section);
      }
    }
  }
  return (group: GroupBase): Group => {
    const sectionsForGroup = sectionsByGroup.get(group.systemId) || [];
    return assoc('sections', sectionsForGroup, group);
  };
};

export const transformGroups = (groups: GroupBase[], sectionsWithItems: AnySection[]): Group[] =>
  pipe<GroupBase[], GroupBase[], Group[], Group[]>(
    sortByIndex,
    map(addSections(sectionsWithItems, groups)),
    filterEntitiesWithChildren('sections'),
  )(groups);
